export default {
  loading: 'Chargement du réapprovisionnement...',
  errorTitle: 'Réapprovisionnement Introuvable',
  notFound: 'Le réapprovisionnement demandé n\'a pas pu être trouvé',
  fetchError: 'Échec du chargement du réapprovisionnement',
  refillDetails: 'Détails du Réapprovisionnement',
  unitsAdded: 'unités ajoutées',
  resource: 'Ressource',
  refiller: 'Réapprovisionneur',
  quantityAdded: 'Quantité Ajoutée',
  refilledAt: 'Réapprovisionné le',
  notes: 'Notes'
};
